import Api from 'libs/api/index';

class DomainsApi extends Api {
  constructor() {
    super('domains');
  }
}

export default DomainsApi;
